import { render, staticRenderFns } from "./myGroupCard.vue?vue&type=template&id=4171ab6e&scoped=true&"
import script from "./myGroupCard.vue?vue&type=script&lang=js&"
export * from "./myGroupCard.vue?vue&type=script&lang=js&"
import style0 from "./myGroupCard.vue?vue&type=style&index=0&id=4171ab6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4171ab6e",
  null
  
)

export default component.exports